import type { FC } from 'react';
import React, { createContext, useState, useCallback, useContext, useMemo } from 'react';
import useEvent from 'react-use/lib/useEvent';

import { useEffectAfterMount } from '../../helpers/use-effect-after-mount';
import type { IToggle } from '../../models';

export interface IToggleContext {
    on: boolean;
    toggle: () => void;
}

const ToggleContext = createContext({} as IToggleContext);

export const useToggleContext = () => useContext(ToggleContext);

export const Toggle: FC<React.PropsWithChildren<IToggle>> = ({ children, onToggle = () => {} }) => {
    const [on, setOn] = useState(false);
    const toggle = useCallback(() => setOn(oldOn => !oldOn), []);

    useEffectAfterMount(() => {
        onToggle(on);
    }, [on]);

    /* Сброс состояния при переходе на страницу через кнопку "назад" в браузере */
    /* istanbul ignore next */
    const onPageShow = (evt: PageTransitionEvent) => {
        if (evt.persisted) setOn(false);
    };

    useEvent('pageshow', onPageShow);

    const value = useMemo(() => ({ on, toggle }), [on, toggle]);

    return <ToggleContext.Provider value={value}>{children}</ToggleContext.Provider>;
};
